module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/related/vi/2-f8fae609e2a33254543a4cae3cc89575.jpg";